import { UserModuleModel, UserModulesExists } from '../shared/models/general-model';
import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { Modules } from "../shared/models/general-model";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-auto-migrate-users',
  templateUrl: './auto-migrate-users.component.html',
  styleUrls: ['./auto-migrate-users.component.scss']
})
export class AutoMigrateUsersComponent implements OnInit {
  min: number;
  max: number;
  searchPage = 1;
  options: Array<any> = [];
  errorMsg = "";
  modalRef: BsModalRef;
  message: string;
  getPaginationCount;
  show: boolean;
  importFile:boolean = false;
  editFile:boolean = false;
  excel_data : boolean = true;
  csmFile : any ;


  rejectedExcelData :any = [];
  approvedExcelData : any = [];
  rejectedExcel : any = "" ;
  approvedExcel : any = "";
  file : any;


  public headers;
  public columns;
  public save = true;
  public notice = true;
  public month;
  public year;
  public ro_name = [];
  public moduleId;
  public modules: Modules[];
  public userList: any[];
  public excel = [
    {
      outlet_code: "",
    },
  ];
  fileName: string = "";
  excelData: any[];

  constructor(
    private exportExcelService : ExportExcelService,
    private xls : XlsxService,
    private modalService : NgbModal,
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private toast : ToastClientService,
    private uploadFile: UploadZipService,
    // private modalService: BsModalService,
    public alertService: AlertService,
    public ngxService: NgxUiLoaderService
  ) {

    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        console.log(message);
        //this.getList();
       // this.getUserExportList();
      }
    });
   }

  ngOnInit() {
  }

  




  downloadExcel(){
    let header = ["Name","Mobile_Number"];
    let filename = "new_csm_onbording_";
    this.exportExcelService.commonPrintHeaders(header, filename);
  }

  xlsxView(data) {

    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        let data = {
          outlets : []
        };
        result.forEach(e => {
          data.outlets.push(e)
        });
        this.apiService.post(this.apiConfig.importNewUsers, result).subscribe((res : any) => {
          console.log(res);
        })
        
      },
      (reason) => { }
    );
  }

  importExcel(event) {
    // debugger
    this.editFile = true;
    this.importFile = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.file = event.target.files[0];
    }
    this.xls.uploadXlsx(event).then((res: any) => {
      console.log(this.excelData)
      this.headers = res.headers;
      this.columns = res.data;
      console.log(this.columns)
      this.save = false;
      this.notice = false;
      this.excelData = res;
      this.editFile = false;
    //  debugger
      if(this.columns.length != 0){
        this.excel_data = false;
      }
     
    });
  }


  onSave(modal){
    this.modalService.open(modal,{ size: 'xl' })
  }

  openExcelDeatail(excelmodel,data){
    this.modalService.dismissAll()
    
    
        let payload = {
          data: data,
        };

  
    this.apiService.post(this.apiConfig.newCsmOnbording , payload).subscribe((res :any)=>{
      console.log(res.body.data.rejected);
      this.toast.Success("Excel Upload Sucessfully")
      this.rejectedExcelData = res.body.data.failure_array;
      this.approvedExcelData = res.body.data.inserted;
      this.rejectedExcel = res.body.data.failure_count;
      this.approvedExcel = res.body.data.success_count;
      this.modalService.open(excelmodel)
    })
  }

  ApprovedExacel(){
    console.log('approved : ',this.approvedExcelData);

    let sheetName = "sheet1";
    let filename = "new_csm_onbording_approved";
    let excelData = this.approvedExcelData;
    let excelArray = [
      { header: 'Mobile_Number', key: 'mobile_number'},
      { header: 'reason', key: 'reason'}
    ]
    this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
  }
  rejectedExacel(){
    let sheetName = "sheet1";
    let filename = "new_csm_onbording_rejected";
    let excelData = this.rejectedExcelData;
    let excelArray = [
      { header: 'Mobile_Number', key: 'mobile_number'},
      { header: 'reason', key: 'reason'}
    ]
    this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);

  }

 

  dismissModal(){
    this.file = "";
    this.fileName = "";
    this.csmFile = null
    this.excel_data = true
    this.modalService.dismissAll();
  }


  
  

}
